import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import Component from '../Component';
/**
 * The background component sets a basic color background of a scene that
 * is more performant than `a-sky` since geometry is not created.
 * There are no undesired frustum culling issues when `a-sky` is further than
 * the far plane of the camera. There are no unexpected occlusions either with
 * far objects that might be behind of the sphere geometry of `a-sky`.
 *
 * @see https://aframe.io/docs/1.3.0/components/background.html
 */

export var Background = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Background, _Component);

  function Background() {
    return _Component.apply(this, arguments) || this;
  }

  return Background;
}(Component);